module.exports = __webpack_public_path__ + "../static/media/fondo.2bd64018.png";